<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3" id="calibre_pb_0"></div>
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">ACKNOWLEDGMENTS</span></h1>
<p class="p_normal"> </p>
<p class="p_normal"> </p>
<p class="p_norm-noindent"><span class="calibre4">SPECIAL THANKS</span> to F.E. Feeley Jr. for writing a song for me!</p>
<p class="p_normal">And of course to Noah Willoughby, Chris Scully, C.L. Miles, and Angelia Sparrow for your unbelievable help with research.</p>
<p class="p_normal">Thanks to Andi Byassee, which really goes without saying. I don’t know what I would do if I didn’t have her at my back. Especially with <span class="calibre2">Blue</span>.</p>
<p class="p_normal">Thanks also to Brian Holliday. I mean it, man. Thank you.</p>
<p class="p_normal">Tippy! Thank you so much! You saved me, man. Wow!</p>
<p class="p_normal">And most especially to Lynn. Who saved this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?6325a3ca